import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { MethodOptionCategoryInterface } from '../../+models';
import { MethodOptionCategoriesActionTypes, MethodOptionCategoriesActions } from './method-option-category.actions';

export const NAME = 'methodOptionCategories';

export interface State extends EntityState<MethodOptionCategoryInterface> {
  // additional entities state properties
  loaded: boolean;
  error?: Error;
}

const sortByKey = (a: MethodOptionCategoryInterface, b: MethodOptionCategoryInterface): number =>
  a.key.localeCompare(b.key);

export const adapter: EntityAdapter<MethodOptionCategoryInterface> =
  createEntityAdapter<MethodOptionCategoryInterface>({
    sortComparer: (a, b) => sortByKey(a, b),
  });

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loaded: false,
});

export function reducer(state = initialState, action: MethodOptionCategoriesActions): State {
  switch (action.type) {
    case MethodOptionCategoriesActionTypes.MethodOptionCategoriesLoaded: {
      return adapter.setAll(action.payload.methodOptionCategories, { ...state, loaded: true });
    }

    case MethodOptionCategoriesActionTypes.MethodOptionCategoriesLoadError: {
      return { ...state, error: action.payload, loaded: false };
    }

    case MethodOptionCategoriesActionTypes.LoadMethodOptionCategories: {
      return { ...state, loaded: false };
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
